import { useContext } from 'react';
import { Top25Context } from '@/utils/top25';
import ManagerIcon from '@/components/SHARED/manager-icon/manager-icon.component';

// A team's name, with its Top 25 rank after it: "Stoneborough State (2)",
// and a user icon when a user manages it (where ShowManagersContext is on).
// nameClass: wrap just the name in a span with this class (e.g. to hide it
// on phones while keeping the rank and icon).
const TeamName = ({ team, id, nameClass }) => {
    const top25 = useContext(Top25Context);
    const rank = top25[id ?? team?.id];
    return (
        <>
            {nameClass ? <span className={nameClass}>{team?.name}</span> : team?.name}
            {rank && <span className='top25-rank'> ({rank})</span>}
            <ManagerIcon team={team} />
        </>
    );
}

export default TeamName
